import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NotFound from "./components/NotFound";
import Login from "./components/Login/Login";
import Diary from "./components/RightScreenComponents/Diary/Diary";
import Dashboard from "./components/RightScreenComponents/Dashboard/Dashboard";
import Patient from "./components/RightScreenComponents/Patient/Patient";
function App() {
  return (
    <div>
      <Router>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/login" element={<Login />} />
          <Route path="/diary" element={<Diary />} />
          <Route path="/Patient" element={<Patient />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
